/* Hush: keep the "+ Add 1 box" bundle nudge inside the cart drawer (no redirect to /cart). */
(function () {
  if (window.__hushAddBound) return;
  window.__hushAddBound = true;

  document.addEventListener('submit', async function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[data-hush-add]') : null;
    if (!form) return;
    var drawer = form.closest('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return; // cart page: normal submit

    e.preventDefault();
    var btn = form.querySelector('button');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }

    try {
      var sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      var res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: 1,
          sections: sections,
          sections_url: window.location.pathname
        })
      });
      if (!res.ok) throw new Error('add failed');
      drawer.renderContents(await res.json());
    } catch (err) {
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
      form.submit();
    }
  });
})();
